import type { Dispatch, FC, ReactNode, SetStateAction } from "react";
import { createContext, useContext, useState } from "react";
import type { FormDetails } from "./ApplicationContext";

interface FormContextType {
  handleSubmit: (() => Promise<FormDetails>) | null; // Function to handle form submission
  setHandleSubmit: Dispatch<SetStateAction<(() => Promise<FormDetails>) | null>>; // Setter for handleSubmit
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export const FormProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [handleSubmit, setHandleSubmit] = useState<(() => Promise<FormDetails>) | null>(null);

  return (
    <FormContext.Provider value={{ handleSubmit, setHandleSubmit }}>
      {children}
    </FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
